import { inject } from '@angular/core'
import { Router, CanActivateFn } from '@angular/router'
import { SessionQuery } from '@app/core'

export const authenticateGuard: CanActivateFn = (_, state) => {
  const router = inject(Router)
  const session = inject(SessionQuery)

  const redirectUrl = state.url.includes('/logout') ? null : state.url

  if (!session.isLoggedIn()) {
    return router.createUrlTree(['/login'], {
      queryParams: {
        redirect: redirectUrl,
      },
    })
  }

  return true
}
